import * as React from "react";
function ChevronDownIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11.999 17a.895.895 0 01-.624-.244l-9.27-9.151a.332.332 0 01.036-.513A.453.453 0 012.416 7c.12 0 .234.045.313.123l9.27 9.15 9.272-9.15A.446.446 0 0121.584 7c.101 0 .2.033.275.091a.333.333 0 01.036.514l-9.271 9.15a.912.912 0 01-.625.244z"
  }));
}
const ForwardRef = React.forwardRef(ChevronDownIcon);
export default ForwardRef;